import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFolderCloud: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="folder-cloud"><path d="M12.75 19.25H21.25V6.75H12L10 3.75H2.75V11.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M4.75 14.25C5.86396 14.25 6.83504 14.8567 7.35254 15.7568C7.40137 15.7537 7.45046 15.75 7.5 15.75C8.74264 15.75 9.75 16.7574 9.75 18C9.75 19.2426 8.74264 20.25 7.5 20.25H4.75C3.09315 20.25 1.75 18.9069 1.75 17.25C1.75 15.5931 3.09315 14.25 4.75 14.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconFolderCloud;
